import {getPrivateAxios} from '../../libs';

export const fetchGuideStepDelete = async (guideId: string, stepId: string) => {
  return getPrivateAxios()
    .delete<void>(`/guides/${guideId}/steps/${stepId}`)
    .then((r) => r.data);
};
